import type { NextPage, GetServerSideProps } from "next";
import Home from "@src/components/Home";
import HomeT2 from "@src/components/Template2/Home";
import HomeT3 from "@src/components/Template3/Home";
import HomeT4 from "@src/components/Template4/Home";
import HomeT5 from "@src/components/Template5/Home";
// import HomeT6 from "@src/components/Template6/Home";
import HomeT7 from "@src/components/Template7/Home";
import HomeT8 from "@src/components/Template8/Home";
import HomeT9 from "@src/components/Template9/Home";
import HomeT10 from "@src/components/Template10/Home";
import HomeT11 from "@src/components/Template11/Home";
import HomeT12 from "@src/components/Template12/Home";
import HomeT13 from "@src/components/Template13/Home";
import HomeT14 from "@src/components/Template14/Home";
import HomeT15 from "@src/components/Template15/Home";
import HomeT16 from "@src/components/Template16/Home";
import HomeT17 from "@src/components/Template17/Home";
import HomeT18 from "@src/components/Template18/Home";
import HomeT20 from "@src/components/Template20/Home";
import HomeT22 from "@src/components/Template22/Home";
import HomeBT1 from "@src/components/BirthdayTemplate1/Home";
import HomeBT2 from "@src/components/BirthdayTemplate2/Home";
import HomeCT1 from "@src/components/CustomTemplate1/Home";
import HomeCT2 from "@src/components/CustomTemplate2/Home";
import HomeBT3 from "@src/components/BirthdayTemplate3/Home";

import { getCookie, deleteCookie, setCookie } from "cookies-next";
import {
  EventBySlug,
  EventParts,
  EventVendor,
  GET_FAQS_BY_EVENT,
  GetAlbumDetails,
  GetAsoEbi,
  GetBackStory,
  GetEventStreamers,
  GetHeroImage,
  GetLiveSchedule,
  GetEventRecommendationLists,
  GetWeddingParty,
  Refresh,
} from "@src/graphql/queries";
import initApolloClient, {
  createApolloClient,
  withApollo,
} from "../apollo-client";
import {
  EventBySlugQuery,
  EventBySlugQueryVariables,
  EventPartsQuery,
  EventPartsQueryVariables,
  EventVendorQuery,
  EventVendorQueryVariables,
  GetAlbumDetailsQuery,
  GetAlbumDetailsQueryVariables,
  GetBackStoryQuery,
  GetBackStoryQueryVariables,
  GetEventRecommendationListsQuery,
  GetEventRecommendationListsQueryVariables,
  GetEventStreamersQuery,
  GetEventStreamersQueryVariables,
  GetFaQsByEventQuery,
  GetFaQsByEventQueryVariables,
  GetHeroImageQuery,
  GetHeroImageQueryVariables,
  GetLiveScheduleQuery,
  GetLiveScheduleQueryVariables,
  GetWeddingPartyQuery,
  GetWeddingPartyQueryVariables,
  RefreshQuery,
  RefreshQueryVariables,
  SignupByInviteLinkMutation,
  SignupByInviteLinkMutationVariables,
} from "@src/@types/api.d";

import jwt_decode, { JwtPayload } from "jwt-decode";
import { SignUpByInviteLink } from "@src/graphql/mutations";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import * as React from "react";
import Icon from "@src/components/Icon";
import toast from "react-hot-toast";
import HomeT6 from "@src/components/Template6/Home";
import { useWebsiteViewTracking } from "@src/hooks/useWebsiteViewTracking";
import HomeT19 from "@src/components/Template19/Home";
import useStore from "@src/store";
import HomeT21 from "@src/components/Template21/Home";

type IndexType = {
  version: number;
  slug: string;
  event_id_query: number;
  refreshTokenExpired: boolean;
  hasWallet: boolean;
  eventLoadError?: boolean;
  eventBySlugData?: EventBySlugQuery;
  weddingName?: string;
  weddingMsg?: string;
  eventPartsData: EventPartsQuery;
  backStoryData: GetBackStoryQuery;
  eventVendorData: EventVendorQuery;
  albumDetailsData: GetAlbumDetailsQuery;
  heroImageData: GetHeroImageQuery;
  getEventStreamersData: GetEventStreamersQuery;
  getLiveScheduleData: GetLiveScheduleQuery;
  weddingPartyData: GetWeddingPartyQuery;
  faqData: GetFaQsByEventQuery;
  recommendationData: GetEventRecommendationListsQuery;
  inviteResult?: SignupByInviteLinkMutation | null;
  previewMode: boolean;
};

const DEFAULT_SOCIAL_IMAGE =
  "https://res.cloudinary.com/drqltx8ye/image/upload/v1636616812/Cover_pcqimz.png";

const SUPPORTED_SHARE_IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "avif",
];

function getFileExtension(url?: string | null): string {
  if (!url) {
    return "";
  }

  try {
    const cleanUrl = url.split("?")[0];
    const filename = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
    const extension = filename.substring(filename.lastIndexOf(".") + 1);

    return extension.toLowerCase();
  } catch (error) {
    return "";
  }
}

function getShareImageUrl(
  heroImageUrl?: string | null,
  heroImageThumbnailUrl?: string | null
): string {
  const thumbnailExtension = getFileExtension(heroImageThumbnailUrl);
  const hasSupportedThumbnail =
    !!heroImageThumbnailUrl &&
    SUPPORTED_SHARE_IMAGE_EXTENSIONS.includes(thumbnailExtension);

  if (hasSupportedThumbnail) {
    return heroImageThumbnailUrl;
  }

  const heroImageExtension = getFileExtension(heroImageUrl);
  const hasSupportedHeroImage =
    !!heroImageUrl &&
    SUPPORTED_SHARE_IMAGE_EXTENSIONS.includes(heroImageExtension);

  if (hasSupportedHeroImage) {
    return heroImageUrl as string;
  }

  return DEFAULT_SOCIAL_IMAGE;
}

const Index: NextPage<IndexType> = ({
  slug,
  event_id_query,
  eventBySlugData,
  weddingName,
  weddingMsg,
  eventPartsData,
  backStoryData,
  eventVendorData,
  albumDetailsData,
  heroImageData,
  refreshTokenExpired,
  hasWallet,
  eventLoadError,
  getEventStreamersData,
  getLiveScheduleData,
  weddingPartyData,
  faqData,
  recommendationData,
  inviteResult,
  previewMode,
}) => {
  const router = useRouter();
  const setIsPreviewMode = useStore((state) => state.setIsPreviewMode);
  const siteUrl = `https://${slug}.inawo.wedding`;
  const shareImageUrl = getShareImageUrl(
    heroImageData?.getHeroImage,
    eventBySlugData?.eventBySlug?.hero_image_thumbnail
  );

  // Track website view when the page loads
  useWebsiteViewTracking({
    eventUuid: eventBySlugData?.eventBySlug?.uuid || "",
    enabled: !!eventBySlugData?.eventBySlug?.uuid,
  });

  React.useEffect(() => {
    setIsPreviewMode(previewMode);
  }, [previewMode, setIsPreviewMode]);

  React.useEffect(() => {
    const linkType = router.query.type;

    router.replace(
      {
        pathname: "/",
        query: linkType ? { type: linkType } : {},
      },
      undefined,
      { shallow: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (refreshTokenExpired) {
      toast(
        <p className="toast">
          You&apos;re currently logged out. <br />
          To refresh, use the <span className="bold"> invite link </span> or
          open this event from your{" "}
          <span className="bold">Inawo dashboard</span>.
        </p>,
        {
          duration: 10000,
          style: {
            background: "#fff8e6",
            border: "0.5px dashed #ffb800",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 8px",
            fontFamily: "Nunito Sans",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "19px",
            textAlign: "center",
            color: "#996e00",
            borderRadius: "0px",
          },
        }
      );
    }
  }, [refreshTokenExpired]);

  const sharedHomeProps = {
    slug,
    hasWallet,
    eventId: event_id_query,
    eventBySlugData,
    eventPartsData,
    backStoryData,
    eventVendorData,
    albumDetailsData,
    heroImageData,
    getEventStreamersData,
    liveSchedules: getLiveScheduleData,
    eventUuid: eventBySlugData?.eventBySlug?.uuid,
    weddingPartyData,
    faqData,
    recommendationData,
    inviteResult,
  };

  return (
    <>
      <Head>
        <title>{weddingName}</title>
        <meta name="application-name" content={weddingName} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="apple-mobile-web-app-title" content={weddingName} />
        <meta name="description" content={weddingMsg} />
        <meta name="format-detection" content="telephone=no" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="msapplication-config" content="/browserconfig.xml" />
        <meta name="msapplication-tap-highlight" content="no" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content={siteUrl} />
        <meta name="twitter:title" content={weddingName} />
        <meta name="twitter:description" content={weddingMsg} />
        <meta name="twitter:image" content={shareImageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={weddingName} />
        <meta property="og:description" content={weddingMsg} />
        <meta property="og:site_name" content={weddingName} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:image" content={shareImageUrl} />
      </Head>
      {eventLoadError ? (
        <div
          style={{
            position: "relative",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "Nunito Sans, sans-serif",
            textAlign: "center",
            backgroundColor: "#fafafa",
          }}
        >
          <Link
            href={
              process.env.NEXT_PUBLIC_API_LANDING_URL || "https://inawo.com/"
            }
            passHref
          >
            <button
              style={{
                position: "absolute",
                top: "24px",
                left: "24px",
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <Icon iconName="logo" />
            </button>
          </Link>
          <p
            style={{
              fontSize: "18px",
              color: "#333",
              marginBottom: "8px",
            }}
          >
            Something went wrong loading this event.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "24px",
            }}
          >
            This might be a temporary connection issue. Please check the link
            and try again.
          </p>
          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              onClick={() => router.reload()}
              style={{
                padding: "6px 20px",
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                color: "#fff",
                backgroundColor: "#34544F",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Retry
            </button>
            <Link
              href={
                process.env.NEXT_PUBLIC_API_LANDING_URL || "https://inawo.com/"
              }
              passHref
            >
              <a
                style={{
                  padding: "6px 20px",
                  fontSize: "14px",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  color: "#34544F",
                  backgroundColor: "transparent",
                  border: "2px solid #34544F",
                  borderRadius: "8px",
                  cursor: "pointer",
                  textDecoration: "none",
                  display: "inline-block",
                }}
              >
                Go to Inawo
              </a>
            </Link>
          </div>
        </div>
      ) : eventBySlugData?.eventBySlug?.template_id === "merlot" ? (
        <HomeT21 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "lumiere" ? (
        <HomeT20 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "opalite" ? (
        <HomeT22 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "monet" ? (
        <HomeCT2 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "regal" ? (
        <HomeT19 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "aevum" ? (
        <HomeBT3 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "timeless" ? (
        <HomeBT2 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "bliss" ? (
        <HomeCT1 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "pop" ? (
        <HomeBT1 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "royale" ? (
        <HomeT18 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "ivory" ? (
        <HomeT17 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "obsidian" ? (
        <HomeT16 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "luz" ? (
        <HomeT15 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "berry" ? (
        <HomeT14 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "viola" ? (
        <HomeT13 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "sunset" ? (
        <HomeT12 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "clover" ? (
        <HomeT11 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "fairy" ? (
        <HomeT10 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "french" ? (
        <HomeT9 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "funky" ? (
        <HomeT8 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "blanc" ? (
        <HomeT7 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "lilac" ? (
        <HomeT6 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "lumen" ? (
        <HomeT5 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "eterna" ? (
        <HomeT4 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "assistant-pilot" ? (
        <HomeT3 {...sharedHomeProps} />
      ) : eventBySlugData?.eventBySlug?.template_id === "pilot" ? (
        <HomeT2 {...sharedHomeProps} />
      ) : (
        <Home {...sharedHomeProps} />
      )}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const host = context?.req?.headers?.host ?? "";
  const hostname = host.split(":")[0];
  const isLocalhost =
    hostname.includes("localhost") || hostname.includes("127.0.0.1");
  const isLocalDevSubdomain =
    isLocalhost ||
    hostname.endsWith(".nip.io") ||
    hostname.endsWith(".sslip.io");
  const isLocalDevHost = isLocalDevSubdomain;
  const subdomain = host?.split(".")[0] ?? "";

  // if url ends with *.inawo.<tld> or localhost, use subdomain; else use full domain as slug
  const domainOrSlug =
    isLocalDevSubdomain || (host && /\.inawo\.[^.]+$/.test(host))
      ? subdomain
      : host;

  if (!subdomain || subdomain === "www") {
    return {
      redirect: {
        destination:
          process.env.NEXT_PUBLIC_API_LANDING_URL || "https://inawo.com/",
        permanent: true,
      },
    };
  }

  let refreshTokenExpired = false;

  const query = context.query;
  const req = context.req;
  const res = context.res;
  const coupleQuery = query?.couple;
  const previewMode = Array.isArray(coupleQuery)
    ? coupleQuery[0] === "true"
    : coupleQuery === "true";

  const cookieOptions = {
    req,
    res,
    maxAge: 90 * 60 * 60 * 24,
    sameSite: "lax" as const,
    secure: !isLocalDevHost,
    path: "/",
  };

  // coming from the invite link
  const otp = query?.token as string | undefined;
  const eventId = query?.eventId as string | undefined;

  // fallback when the browser URL has been cleaned up
  const otpFromCookie = getCookie("invtk", { req, res }) as string | undefined;
  const eventIdFromCookie = getCookie("inveid", {
    req,
    res,
  }) as string | undefined;

  const resolvedOtp = otp || otpFromCookie;
  const resolvedEventId = eventId || eventIdFromCookie;

  // coming from the dashboard
  const refreshToken = query?.evd as string;

  // these can still be undefined
  let currentAccessToken = getCookie("tsl", { req, res }) as string;
  let currentRefreshToken = getCookie("evd", { req, res }) as string;
  let inviteResult: SignupByInviteLinkMutation | null = null;

  let client: ReturnType<typeof createApolloClient> = initApolloClient(
    {},
    !!currentAccessToken ? currentAccessToken : "",
    context
  );

  if (otp && eventId) {
    setCookie("invtk", otp, cookieOptions);
    setCookie("inveid", eventId, cookieOptions);
  }

  const shouldRunInviteMutation =
    !!resolvedOtp && !!resolvedEventId && !previewMode;

  if (shouldRunInviteMutation) {
    try {
      const { data, errors } = await client.mutate<
        SignupByInviteLinkMutation,
        SignupByInviteLinkMutationVariables
      >({
        mutation: SignUpByInviteLink,
        variables: {
          inviteToken: resolvedOtp,
          eventId: Number(resolvedEventId),
        },
      });

      console.log({
        first_name: data?.signupByInviteLink?.auth_response?.user?.first_name,
        last_name: data?.signupByInviteLink?.auth_response?.user?.last_name,
        rsvp_status: data?.signupByInviteLink?.invitation.rsvp_status,
        seating: data?.signupByInviteLink?.invitation.seating,
        qrcode: data?.signupByInviteLink?.invitation.qr_code,
        errors,
      });

      if (!!data && data.signupByInviteLink) {
        inviteResult = data;
        currentAccessToken = data.signupByInviteLink.auth_response.access_token;
        currentRefreshToken =
          data.signupByInviteLink.auth_response.refresh_token;

        setCookie("evd", data.signupByInviteLink.auth_response.refresh_token, {
          ...cookieOptions,
        });
        setCookie("tsl", data.signupByInviteLink.auth_response.access_token, {
          ...cookieOptions,
        });
        setCookie("invitationUuid", data.signupByInviteLink.invitation.uuid, {
          ...cookieOptions,
        });
        setCookie(
          "invitationRsvpStatus",
          data.signupByInviteLink.invitation.rsvp_status ?? "",
          cookieOptions
        );
        setCookie("usI", data.signupByInviteLink.auth_response?.user?.id, {
          ...cookieOptions,
        });
      }

      if (errors) {
        console.error("Invite token error:>> ", errors);
      }
    } catch (error) {
      console.error("Invite token error:>> ", error);
    }
  }

  if (!!refreshToken) {
    // remove previously set cookies if they exist
    deleteCookie("tsl", { req, res });
    deleteCookie("usI", { req, res });
    setCookie("evd", refreshToken, { req, res, maxAge: 90 * 60 * 60 * 24 });

    try {
      const { data, error } = await client.query<
        RefreshQuery,
        RefreshQueryVariables
      >({
        query: Refresh,
        variables: {
          refreshToken,
        },
      });

      if (!!data) {
        currentAccessToken = data.refresh.access_token;
        currentRefreshToken = data.refresh.refresh_token;

        setCookie("evd", data.refresh.refresh_token, {
          req,
          res,
          maxAge: 90 * 60 * 60 * 24,
        });
        setCookie("tsl", data.refresh.access_token, {
          req,
          res,
          maxAge: 90 * 60 * 60 * 24,
        });
        setCookie("usI", data.refresh?.user?.id, {
          req,
          res,
          maxAge: 90 * 60 * 60 * 24,
        });
      }

      if (error) {
        console.error("Refresh string error:>> ", error);
      }
    } catch (error) {
      console.error("Refresh string error:>> ", error);
    }
  }

  if (!!currentRefreshToken) {
    let decodedRefreshJwt = jwt_decode<JwtPayload>(
      currentRefreshToken as string
    );

    if (!!decodedRefreshJwt.exp && decodedRefreshJwt.exp * 1000 < Date.now()) {
      refreshTokenExpired = true;

      deleteCookie("tsl", { req, res });
      deleteCookie("usI", { req, res });
      deleteCookie("evd", { req, res });

      // return {
      //   redirect: {
      //     destination:
      //       process.env.NEXT_PUBLIC_API_LANDING_URL || "https://inawo.com/",
      //     permanent: false,
      //   },
      // };

      // Don't redirect: stay on event page and let the client show the "logged out" toast
      currentAccessToken = "" as string;
      currentRefreshToken = "" as string;
    }
  }

  if (!!currentAccessToken) {
    let decodedAccessJwt = jwt_decode<JwtPayload>(currentAccessToken as string);

    if (
      !!decodedAccessJwt.exp &&
      decodedAccessJwt.exp * 1000 < Date.now() - 10000
    ) {
      try {
        const { data, error } = await client.query<
          RefreshQuery,
          RefreshQueryVariables
        >({
          query: Refresh,
          variables: {
            refreshToken: currentRefreshToken,
          },
        });

        if (!!data) {
          currentAccessToken = data.refresh.access_token;
          currentRefreshToken = data.refresh.refresh_token;

          setCookie("evd", data.refresh.refresh_token, {
            req,
            res,
            maxAge: 90 * 60 * 60 * 24,
          });
          setCookie("tsl", data.refresh.access_token, {
            req,
            res,
            maxAge: 90 * 60 * 60 * 24,
          });
          setCookie("usI", data.refresh?.user?.id, {
            req,
            res,
            maxAge: 90 * 60 * 60 * 24,
          });
        }

        if (error) {
          console.error("Refresh error:>> ", error);
          deleteCookie("evd");
          deleteCookie("tsl");
          deleteCookie("usI");
          refreshTokenExpired = true;
        }
      } catch (error) {
        console.error("Refresh error:>> ", error);
        deleteCookie("evd");
        deleteCookie("tsl");
        deleteCookie("usI");
        refreshTokenExpired = true;
      }
    }
  }

  // The Apollo auth link captures the access token when the client is created.
  // Invite-link and dashboard authentication above can replace that token during
  // this request, so rebuild the server client before loading protected event
  // data. Otherwise the first render still uses the old (often empty) token and
  // only becomes authenticated after a refresh reads the newly written cookie.
  client = initApolloClient(
    {},
    currentAccessToken || "",
    currentRefreshToken,
    context
  );

  let event_id = resolvedEventId || ("" as string | number);
  let eventUuid = "";
  let weddingName = "";
  let weddingMsg = "";
  let hasWallet = false;

  let eventBySlugData = {} as EventBySlugQuery;
  let eventPartsData = {} as EventPartsQuery;
  let backStoryData = {} as GetBackStoryQuery;
  let albumDetailsData = {} as GetAlbumDetailsQuery;
  let eventVendorData = {} as EventVendorQuery;
  let heroImageData = {} as GetHeroImageQuery;
  let getEventStreamersData = {} as GetEventStreamersQuery;
  let getLiveScheduleData = {} as GetLiveScheduleQuery;
  let weddingPartyData = {} as GetWeddingPartyQuery;
  let faqData = {} as GetFaQsByEventQuery;
  let recommendationData = {} as GetEventRecommendationListsQuery;
  let version = new Date().getTime();

  try {
    const { data } = await client.query<
      EventBySlugQuery,
      EventBySlugQueryVariables
    >({
      query: EventBySlug,
      variables: {
        slug: domainOrSlug,
      },
    });

    if (data) {
      eventBySlugData = data;
      console.log({
        access_control: data.eventBySlug?.event_preference?.access_control,
      });
    }

    // Event not found for this slug, so redirect to landing
    if (!eventBySlugData?.eventBySlug) {
      return {
        redirect: {
          destination:
            process.env.NEXT_PUBLIC_API_LANDING_URL || "https://inawo.com/",
          permanent: false,
        },
      };
    }
  } catch (error) {
    // Transient error (network, server) → stay on page and show retry UI
    console.error("Event Slug error:>> ", error);

    return {
      props: {
        version: new Date().getTime(),
        slug: eventBySlugData.eventBySlug?.slug || "",
        event_id_query: 0,
        refreshTokenExpired: false,
        hasWallet: false,
        eventLoadError: true,
        eventBySlugData: {} as EventBySlugQuery,
        weddingName: "Inawo Wedding",
        weddingMsg: "Inawo Wedding",
        eventPartsData: {} as EventPartsQuery,
        backStoryData: {} as GetBackStoryQuery,
        eventVendorData: {} as EventVendorQuery,
        albumDetailsData: {} as GetAlbumDetailsQuery,
        heroImageData: {} as GetHeroImageQuery,
        getEventStreamersData: {} as GetEventStreamersQuery,
        getLiveScheduleData: {} as GetLiveScheduleQuery,
        weddingPartyData: {} as GetWeddingPartyQuery,
        faqData: {} as GetFaQsByEventQuery,
        recommendationData: {} as GetEventRecommendationListsQuery,
        inviteResult: null,
        previewMode,
        apolloStaticCache: client.cache.extract(true),
        token: !!currentAccessToken ? currentAccessToken : "",
        refreshToken: !!currentRefreshToken ? currentRefreshToken : "",
      },
    };
  }

  event_id =
    !!eventBySlugData && !!eventBySlugData?.eventBySlug?.id
      ? eventBySlugData?.eventBySlug?.id
      : !!resolvedEventId
      ? resolvedEventId
      : 0;

  eventUuid =
    !!eventBySlugData && !!eventBySlugData?.eventBySlug?.uuid
      ? eventBySlugData?.eventBySlug?.uuid
      : "";

  if (eventUuid) {
    setCookie("eventUuid", eventUuid, cookieOptions);
  }

  weddingName =
    !!eventBySlugData && !!eventBySlugData.eventBySlug?.name
      ? `${eventBySlugData.eventBySlug?.name}`
      : "Inawo Wedding";

  weddingMsg =
    !!eventBySlugData && !!eventBySlugData.eventBySlug?.welcome_msg
      ? `${eventBySlugData.eventBySlug?.welcome_msg}`
      : "Inawo Wedding";

  hasWallet =
    !!eventBySlugData &&
    !!eventBySlugData.eventBySlug?.event_wallet &&
    eventBySlugData.eventBySlug?.event_wallet?.length > 0
      ? true
      : false;

  try {
    const queryPromises = [
      client.query<GetHeroImageQuery, GetHeroImageQueryVariables>({
        query: GetHeroImage,
        variables: { eventId: Number(event_id) },
      }),
      client.query<GetEventStreamersQuery, GetEventStreamersQueryVariables>({
        query: GetEventStreamers,
        variables: { eventId: Number(event_id) },
      }),
      client.query<EventPartsQuery, EventPartsQueryVariables>({
        query: EventParts,
        variables: { eventId: Number(event_id) },
      }),
      client.query<GetBackStoryQuery, GetBackStoryQueryVariables>({
        query: GetBackStory,
        variables: { eventId: Number(event_id) },
      }),
      client.query<GetAlbumDetailsQuery, GetAlbumDetailsQueryVariables>({
        query: GetAlbumDetails,
        variables: { eventUuid: eventUuid, page: 1, pageSize: 60 },
      }),
      client.query<EventVendorQuery, EventVendorQueryVariables>({
        query: EventVendor,
        variables: { eventId: Number(event_id), page: 1, pageSize: 60 },
      }),
      client.query<GetLiveScheduleQuery, GetLiveScheduleQueryVariables>({
        query: GetLiveSchedule,
        variables: { eventUuid: eventUuid, page: 1, pageSize: 60 },
      }),
      client.query<GetWeddingPartyQuery, GetWeddingPartyQueryVariables>({
        query: GetWeddingParty,
        variables: { eventId: eventUuid },
      }),
      client.query<GetFaQsByEventQuery, GetFaQsByEventQueryVariables>({
        query: GET_FAQS_BY_EVENT,
        variables: {
          eventId: eventUuid,
          filter: {
            is_active: true,
            // page: 1,
            // pageSize: 10,
          },
        },
      }),
      client.query<
        GetEventRecommendationListsQuery,
        GetEventRecommendationListsQueryVariables
      >({
        query: GetEventRecommendationLists,
        variables: { eventId: eventUuid },
      }),
    ];

    const responses = await Promise.allSettled(queryPromises);

    responses.forEach((response, index) => {
      if (response.status === "fulfilled") {
        const { data } = response.value;
        switch (index) {
          case 0:
            heroImageData = data as GetHeroImageQuery;
            break;
          case 1:
            getEventStreamersData = data as GetEventStreamersQuery;
            break;
          case 2:
            eventPartsData = data as EventPartsQuery;
            break;
          case 3:
            backStoryData = data as GetBackStoryQuery;
            break;
          case 4:
            albumDetailsData = data as GetAlbumDetailsQuery;
            break;
          case 5:
            eventVendorData = data as EventVendorQuery;
            break;
          case 6:
            getLiveScheduleData = data as GetLiveScheduleQuery;
            break;
          case 7:
            weddingPartyData = data as GetWeddingPartyQuery;
            break;
          case 8:
            faqData = data as GetFaQsByEventQuery;
            break;
          case 9:
            recommendationData = data as GetEventRecommendationListsQuery;
            break;
          default:
            break;
        }
      } else {
        const error = response.reason;
        switch (index) {
          case 0:
            console.error("HeroImage error:", error);
            break;
          case 1:
            console.error("Get Streamers error:", error);
            break;
          case 2:
            console.error("Parts error:", error);
            break;
          case 3:
            console.error("Backstory error:", error);
            break;
          case 4:
            console.error("Album error:", error);
            break;
          case 5:
            console.error("Vendor error:", error);
            break;
          case 6:
            console.error("Live Schedule Error:", error);
            break;
          case 7:
            console.error("Wedding Party Error:", error);
            break;
          case 8:
            console.error("FAQ Error:", error);
            break;
          case 9:
            console.error("Recommendation Error:", error);
            break;
          default:
            break;
        }
      }
    });
  } catch (error) {
    console.error("Error:", error);
  }

  return {
    props: {
      version,
      slug: eventBySlugData.eventBySlug?.slug || "",
      event_id_query: Number(resolvedEventId) || Number(event_id) || 0,
      getEventStreamersData,
      eventBySlugData,
      weddingName,
      weddingMsg,
      eventPartsData,
      backStoryData,
      eventVendorData,
      albumDetailsData,
      heroImageData,
      refreshTokenExpired,
      getLiveScheduleData,
      hasWallet,
      apolloStaticCache: client.cache.extract(true),
      token: !!currentAccessToken ? currentAccessToken : "",
      refreshToken: !!currentRefreshToken ? currentRefreshToken : "",
      weddingPartyData,
      faqData,
      recommendationData,
      inviteResult,
      previewMode,
    },
  };
};

export default withApollo(Index);
